__turbopack_context__.v({
  "currentValue": "Range-module__1rypdq__currentValue",
  "rangeContainer": "Range-module__1rypdq__rangeContainer",
  "rangeLabel": "Range-module__1rypdq__rangeLabel",
  "wrapper": "Range-module__1rypdq__wrapper",
});
